/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import AgreementSection from '../components/AgreementSection';
import AntisocialForcesSection from '../components/AntisocialForcesSection';
import BlankSection from '../components/BlankSection';
import BMForbiddenSection from '../components/BMForbiddenSection';
import ConfirmAgreementSection from '../components/ConfirmAgreementSection';
import ConfirmInquirySection from '../components/ConfirmInquirySection';
import ConfirmPaymentAgreementSection from '../components/ConfirmPaymentAgreementSection';
import ConfirmPrivacyPolicySection from '../components/ConfirmPrivacyPolicySection';
import ContactInfoSection from '../components/ContactInfoSection';
import FAQ from '../components/FAQ';
import FenrirSection from '../components/FenrirSection';
import ForbiddenSection from '../components/ForbiddenSection';
import HeaderSection from '../components/HeaderSection';
import HomeCrossSearchSection from '../components/HomeCrossSearchSection';
import HomeNewsSection from '../components/HomeNewsSection';
import HomeSection from '../components/HomeSection';
import Image2Section from '../components/Image2Section';
import ImageSection from '../components/ImageSection';
import InformationSection from '../components/InformationSection';
import InternetErrorSection from '../components/InternetErrorSection';
import LibraryExampleInfoSection from '../components/LibraryExampleInfoSection';
import LibraryInfoSection from '../components/LibraryInfoSection';
import LibrarySearchSection from '../components/LibrarySearchSection';
import LPAgreementSection from '../components/LPAgreementSection';
import LPImageSection from '../components/LPImageSection';
import LPInfoSection from '../components/LPInfoSection';
import LPNewsSection from '../components/LPNewsSection';
import LPPrivacyPolicySection from '../components/LPPrivacyPolicySection';
import MypageInfoSection from '../components/MypageInfoSection';
import MypageResearchInfoSection from '../components/MypageResearchInfoSection';
import NotFoundSection from '../components/NotFoundSection';
import OptionServiceCardSection from '../components/OptionServiceCardSection';
import PaymentAgreementSection from '../components/PaymentAgreementSection';
import PaymentSelectSection from '../components/PaymentSelectSection';
import PersonalInformationProtectionPolicySection from '../components/PersonalInformationProtectionPolicySection';
import PickUpSection from '../components/PickUpSection';
import PolicyInquirySection from '../components/PolicyInquirySection';
import PublishedInfoSection from '../components/PublishedInfoSection';
import RelatedArticleSection from '../components/RelatedArticleSection';
import ResearchInfoSection from '../components/ResearchInfoSection';
import RevealConfirmArticleSection from '../components/RevealConfirmArticleSection';
import RevisionHistorySection from '../components/RevisionHistorySection';
import RichTextSection from '../components/RichTextSection';
import SearchResearchSection from '../components/SearchResearchSection';
import ServicePolicySection from '../components/ServicePolicySection';
import SplitLineSection from '../components/SplitLineSection';
import SplitPageSection from '../components/SplitPageSection';
import SupportTraderSection from '../components/SupportTraderSection';
import TextSection from '../components/TextSection';
import TitleSection from '../components/TitleSection';
import ToolbarSection from '../components/ToolbarSection';
import UsageFeeSection from '../components/UsageFeeSection';
import VideoSection from '../components/VideoSection';

const components = new Map();
components.set('AgreementSection', AgreementSection);
components.set('AntisocialForcesSection', AntisocialForcesSection);
components.set('BlankSection', BlankSection);
components.set('BMForbiddenSection', BMForbiddenSection);
components.set('ConfirmAgreementSection', ConfirmAgreementSection);
components.set('ConfirmInquirySection', ConfirmInquirySection);
components.set('ConfirmPaymentAgreementSection', ConfirmPaymentAgreementSection);
components.set('ConfirmPrivacyPolicySection', ConfirmPrivacyPolicySection);
components.set('ContactInfoSection', ContactInfoSection);
components.set('FAQ', FAQ);
components.set('FenrirSection', FenrirSection);
components.set('ForbiddenSection', ForbiddenSection);
components.set('HeaderSection', HeaderSection);
components.set('HomeCrossSearchSection', HomeCrossSearchSection);
components.set('HomeNewsSection', HomeNewsSection);
components.set('HomeSection', HomeSection);
components.set('Image2Section', Image2Section);
components.set('ImageSection', ImageSection);
components.set('InformationSection', InformationSection);
components.set('InternetErrorSection', InternetErrorSection);
components.set('LibraryExampleInfoSection', LibraryExampleInfoSection);
components.set('LibraryInfoSection', LibraryInfoSection);
components.set('LibrarySearchSection', LibrarySearchSection);
components.set('LPAgreementSection', LPAgreementSection);
components.set('LPImageSection', LPImageSection);
components.set('LPInfoSection', LPInfoSection);
components.set('LPNewsSection', LPNewsSection);
components.set('LPPrivacyPolicySection', LPPrivacyPolicySection);
components.set('MypageInfoSection', MypageInfoSection);
components.set('MypageResearchInfoSection', MypageResearchInfoSection);
components.set('NotFoundSection', NotFoundSection);
components.set('OptionServiceCardSection', OptionServiceCardSection);
components.set('PaymentAgreementSection', PaymentAgreementSection);
components.set('PaymentSelectSection', PaymentSelectSection);
components.set('PersonalInformationProtectionPolicySection', PersonalInformationProtectionPolicySection);
components.set('PickUpSection', PickUpSection);
components.set('PolicyInquirySection', PolicyInquirySection);
components.set('PublishedInfoSection', PublishedInfoSection);
components.set('RelatedArticleSection', RelatedArticleSection);
components.set('ResearchInfoSection', ResearchInfoSection);
components.set('RevealConfirmArticleSection', RevealConfirmArticleSection);
components.set('RevisionHistorySection', RevisionHistorySection);
components.set('RichTextSection', RichTextSection);
components.set('SearchResearchSection', SearchResearchSection);
components.set('ServicePolicySection', ServicePolicySection);
components.set('SplitLineSection', SplitLineSection);
components.set('SplitPageSection', SplitPageSection);
components.set('SupportTraderSection', SupportTraderSection);
components.set('TextSection', TextSection);
components.set('TitleSection', TitleSection);
components.set('ToolbarSection', ToolbarSection);
components.set('UsageFeeSection', UsageFeeSection);
components.set('VideoSection', VideoSection);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
